import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LoadingType } from '../../models/LoadingType';

export interface ITermsAndConditionsSliceState {
  accepted?: boolean;
  loading: LoadingType;
  error?: string;
}

export const initialState: ITermsAndConditionsSliceState = {
  loading: LoadingType.Idle,
  error: undefined
};

export const termsAndConditionsSlice = createSlice({
  name: 'termsAndConditions',
  initialState,
  reducers: {
    updateTermsAndConditions: (state, action) => {
      state.accepted = action.payload;
      state.error = undefined;
    }
  }
});

export const selectLoading = (state: RootState): LoadingType =>
  state.termsAndConditions?.loading;
export const selectError = (state: RootState) =>
  state.termsAndConditions?.error;
export const selectAccepted = (state: RootState): boolean => {
  return state.termsAndConditions?.accepted;
};
export const termsAndConditionsReducer = termsAndConditionsSlice.reducer;
